"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.DateTimePicker = void 0;
var React = require("react");
var react_datepicker_1 = require("react-datepicker");
require("react-datepicker/dist/react-datepicker.css");
var Localization_1 = require("../../Localization");
var DateTimePicker_styles_1 = require("./DateTimePicker.styles");
var Header_1 = require("./Header/Header");
var Input_1 = require("./Input/Input");
require("./react-datepicker-overrides.css");
var DEFAULT_DATETIME_FORMAT = Localization_1.strings.DateTimePicker_Label_DefaultDateFormat + " " + Localization_1.strings.DateTimePicker_Label_DefaultTimeFormat;
// Note this needs to be scoped outside DateTimePicker function
var CustomTimeInput = function (_a) {
    var value = _a.value, onChange = _a.onChange;
    return (React.createElement(DateTimePicker_styles_1.TimeInput, { "aria-label": Localization_1.strings.DateTimePicker_AriaLabel_CustomTimeInput, type: "time", value: value ? value : "", onChange: function (e) { return onChange(e.target.value); } }));
};
var DateTimePicker = function (_a) {
    var HasErrors = _a.HasErrors, IsDisabled = _a.IsDisabled, CalendarMinDate = _a.CalendarMinDate, CalendarMaxDate = _a.CalendarMaxDate, OnBlur = _a.OnBlur, OnChange = _a.OnChange, Value = _a.Value, _b = _a.ShowTime, ShowTime = _b === void 0 ? true : _b, _c = _a.YearOptionsMaxOffset, YearOptionsMaxOffset = _c === void 0 ? 100 : _c, _d = _a.YearOptionsMinOffset, YearOptionsMinOffset = _d === void 0 ? 100 : _d;
    var calenderRef = React.createRef();
    var handleOnChange = function (date) {
        if (!date) {
            OnChange();
        }
        else if (isNaN(date.getTime())) {
            OnChange(new Date());
        }
        else {
            OnChange(date);
        }
    };
    var handlePopperModifiers = {
        flip: { enabled: false },
        preventOverflow: {
            enabled: true,
            escapeWithReference: false,
            // tslint:disable-next-line:object-literal-sort-keys
            boundariesElement: "viewport",
        },
    };
    var datePickerProps = {
        customInput: (React.createElement(Input_1.default, { HasErrors: HasErrors, "aria-label": Localization_1.strings.DateTimePicker_AriaLabel_CustomInput, OnClear: function () { return OnChange(); }, OnClick: function () { return calenderRef.current.setOpen(true); } })),
        dateFormat: ShowTime ? DEFAULT_DATETIME_FORMAT : Localization_1.strings.DateTimePicker_Label_DefaultDateFormat,
        disabled: IsDisabled,
        disabledKeyboardNavigation: true,
        maxDate: CalendarMaxDate,
        minDate: CalendarMinDate,
        onBlur: OnBlur,
        onChange: handleOnChange,
        placeholderText: ShowTime
            ? Localization_1.strings.DateTimePicker_Label_DateTimePlaceholder
            : Localization_1.strings.DateTimePicker_Label_DatePlaceholder,
        popperModifiers: handlePopperModifiers,
        renderCustomHeader: function (params) { return (React.createElement(Header_1.Header, __assign({}, params, { YearOptionsMaxOffset: YearOptionsMaxOffset, YearOptionsMinOffset: YearOptionsMinOffset }))); },
        selected: Value,
        showPopperArrow: false,
        showTimeInput: ShowTime,
        useWeekdaysShort: true,
    };
    // tslint:disable-next-line: no-string-literal
    datePickerProps["customTimeInput"] = React.createElement(CustomTimeInput, null);
    return React.createElement(react_datepicker_1.default, __assign({ ref: calenderRef }, datePickerProps));
};
exports.DateTimePicker = DateTimePicker;
